import ComponentState, { ComponentStateTypes } from "components/common/ComponentState";
import Form from "components/common/form/Form";
import Input from "components/common/form/inputs/Input";
import FormActions from "components/common/form/partials/FormActions";
import { useEffect, useState } from "react";
import { agricultureMaintenanceLogTypeMutation, getAgricultureMaintenanceLogTypeItemQuery } from "types/agriculture/maintenance-log-types";
import { IdName } from "types/common-types";

type AgricultureMaintenanceTypeFormInputsPropsType = {
    model?: number | IdName,
    onSubmit: (data: IdName) => void | Promise<void>,
    name: string
}

const AgricultureMaintenanceTypeFormInputs = (props: AgricultureMaintenanceTypeFormInputsPropsType) => {
    const [state, setState] = useState<ComponentStateTypes>(!props.model || Number(props.model) ? 'loading' : '');
    const [model, setModel] = useState<IdName>({
        id: 0,
        name: ''
    });

    useEffect(() => {
        loadData().then();
    }, []);

    const loadData = async () => {
        const id = Number(props.model);
        if (id) {
            const response = await getAgricultureMaintenanceLogTypeItemQuery({id: id});
            if (response.data?.maintenanceLogType) {
                setModel(response.data.maintenanceLogType);
            }
        }
        else if(props.model) {
            setModel({
                id: typeof props.model == 'object' ? props.model.id || 0 : 0,
                name: typeof props.model == 'object' ? props.model.name || '' : ''
            });
        }
        setState('');
    }

    const onSubmit = async () => {
        try {
            const response = await agricultureMaintenanceLogTypeMutation({
                id: model.id,
                name: model.name
            });

            const submit = props.onSubmit({
                id: response.data?.maintenanceLogType?.id || 0,
                name: model.name
            });
            if (submit instanceof Promise) {
                await submit;
            }
        } catch (error) {
            setState('error');
            throw error;
        }
    };

    return (
        <ComponentState state={state}>
            <Form name={`agricultureMaintenanceTypeForm-${props.name}`} onSubmit={onSubmit}>
                <Input
                    name="name"
                    label="fields.name.name"
                    required
                    maxLength={128}
                    minLength={2}
                    value={model.name}
                    onChange={(v) => setModel({ ...model, name: v || '' })}
                />
                <FormActions />
            </Form>
        </ComponentState>
    );
};

export default AgricultureMaintenanceTypeFormInputs;
